import { render, staticRenderFns } from "./Await.vue?vue&type=template&id=91c417b2&scoped=true&"
import script from "./Await.vue?vue&type=script&lang=js&"
export * from "./Await.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c417b2",
  null
  
)

export default component.exports